export const CREATE_BANK_RECEIPT_RETURN  = 'CREATE_BANK_RECEIPT_RETURN';
export const GET_BANK_RECEIPT_RETURNS  = 'GET_BANK_RECEIPT_RETURNS';
export const GET_BANK_RECEIPT_RETURNS_PAGE  = 'GET_BANK_RECEIPT_RETURNS_PAGE';
export const BANK_RECEIPT_RETURN_REQUEST  = 'BANK_RECEIPT_RETURN_REQUEST';
export const DELETE_BANK_RECEIPT_RETURN  = 'DELETE_BANK_RECEIPT_RETURN';
export const UPDATE_BANK_RECEIPT_RETURN  = 'UPDATE_BANK_RECEIPT_RETURN';
export const BANK_RECEIPT_RETURN_REQUEST_SUCCESS  = 'BANK_RECEIPT_RETURN_REQUEST_SUCCESS';
export const BANK_RECEIPT_RETURN_REQUEST_FAILURE  = 'BANK_RECEIPT_RETURN_REQUEST_FAILURE';